export default "__VITE_ASSET__Bcn0yp2r__"